module.exports = __webpack_public_path__ + "static/media/30.2eda7f49.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/30.png
// module id = 991
// module chunks = 0